import {
    SET_EDITOR_UTILITIES
} from 'redux/actions/types/formBuilder';

export const setEditorUtilities = utilities => ({
    type: SET_EDITOR_UTILITIES,
    utilities
});
